/* eslint-disable no-restricted-syntax */

export function isSuperset(set, subset) {
    for (const elem of subset) {
        if (!set.has(elem)) {
            return false
        }
    }
    return true
}

export function union(setA, setB) {
    const result = new Set(setA)
    for (const elem of setB) {
        result.add(elem)
    }
    return result
}

export function intersection(setA, setB) {
    const result = new Set()
    for (const elem of setB) {
        if (setA.has(elem)) {
            result.add(elem)
        }
    }
    return result
}

export function symmetricDifference(setA, setB) {
    const result = new Set(setA)
    for (const elem of setB) {
        if (result.has(elem)) {
            result.delete(elem)
        } else {
            result.add(elem)
        }
    }
    return result
}

export function difference(setA, setB) {
    const result = new Set(setA)
    for (const elem of setB) {
        result.delete(elem)
    }
    return result
}

// Examples
// var setA = new Set([1, 2, 3, 4]),
//     setB = new Set([2, 3]),
//     setC = new Set([3, 4, 5, 6])
//
// isSuperset(setA, setB) // => true
// union(setA, setC) // => Set [1, 2, 3, 4, 5, 6]
// intersection(setA, setC) // => Set [3, 4]
// symmetricDifference(setA, setC) // => Set [1, 2, 5, 6]
// difference(setA, setC) // => Set [1, 2]
